import styled from 'styled-components';
export const MobileNavigationCtas = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
`;
export const MobileNavigationHdNavigationFooter = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.lg}px;
`;
